const ErrorMessageEnum = Object.freeze({
    COMPANY_CODE_NOT_EXISTS: { value: 'COMPANY_CODE_NOT_EXISTS', text: 'Company code does not exist' },
    EMAIL_HAS_ALREADY_BEEN_TAKEN: { value: 'EMAIL_HAS_ALREADY_BEEN_TAKEN', text: 'The email has already been taken' },
    THE_COMPANY_IS_REJECTED: { value: 'THE_COMPANY_IS_REJECTED', text: 'The company is rejected' },
    THE_CURRENT_PASSWORD_IS_WRONG: { value: 'THE_CURRENT_PASSWORD_IS_WRONG', text: 'The current password is wrong' },
    SEND_MSG_FAIL: { value: 'fail', text: 'Fail' },
});

export default ErrorMessageEnum;
